import {Component, Input, OnInit} from '@angular/core';
import {Grievance} from '../../_services/_modals/grievance.modal';
import {HttpService} from '../../../common/_services/http.service';
import {MainService} from '../../_services/main.service';
import {UtilService} from '../../../common/_services/util.service';
import {ActivatedRoute} from '@angular/router';
import {AppEventService} from '../../../common/_services/event-broadcaster.service';
import {GrievanceService} from '../../_services/grievance.service';
import {CasemanagerComponent} from '../casemanager/casemanager.component';
import { ToastrService } from 'ngx-toastr';
import { AudioRecordingService } from '../../_services/audio-recording.service';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ConfirmBoxComponent } from '../../_dialog_box/confirm-box/confirm-box.component';
import { ImageViewerComponent } from '../../_dialog_box/image-viewer/image-viewer.component';
import { JsonParsePipe } from 'src/app/common/pipes/json.pipe';
import { BlobFile } from 'src/app/common/_modals/blob-file';
import { HelplineResult } from 'src/app/common/_modals/helpline-result';
import { getTranslateText, OK_TXT, CANCEL_TXT, CALL_CONFIRM, CALL_FAIL, CALL_CONNECTING } from '../../multi-lan';

@Component({
  selector: 'app-assigned-items',
  templateUrl: './assign-unassign-items.component.html',
  styleUrls: ['./assign-unassign-items.component.css']
})

export class AssignUnassignItemsComponent implements OnInit {
  public isSaveDisabled = true;
  
@Input()
responses: Array<any>;
@Input()
items: any;
@Input()
itemtype: string;
@Input()
grievances_data: Grievance[] = [];
rejectionReason: any;
showOpt = false;
update_options = [
  {value: 'INPROGRESS', name: 'Update'},
  {value: 'MARKED_RESOLVED', name: 'Mark Resolve'},
  {value: 'HALTED_PROGRESS', name: 'Quit'}

];
fileName : string;
quitreason: any;
audio_file: any;
selectedReason: number = 0;
enableAudio = false;
enableReason = false;
handlers = [];
mod_callerid: string;
ai_id: any;
user_role: string;
handler_id: any;
grievances_id: any;
reference_id: number;
response = [] as any;
grievances_state: any;
spinner: boolean;
comments_array: any;
showUpdate = false;
isRecording:boolean = false;
isUpload:boolean = true;
recordedTime: string;
teste: any;
blobUrl: SafeUrl;
audiofilePath: SafeUrl;
dialogRef: any;
public old_obj = {};
public updatable_field_keys = ['id', 'transcript', 'reason_id', 'sm_image', 'detail',
  'rating',  'title', 'pub_order', 'tags', 'misc', 'state'];
defaultLan: string = 'hi';
imageList: BlobFile[] = [];
  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private audioRecordingService: AudioRecordingService,
    private toastr: ToastrService,
    private mainService: MainService,
    private utilService: UtilService,
    private httpService: HttpService,
    private route: ActivatedRoute,
    public routea: ActivatedRoute,
    private broadcastService: AppEventService,
    private grievanceService: GrievanceService,
    private caseManager: CasemanagerComponent,
    private snackbar: MatSnackBar
    )
    {
    this.routea.queryParams.subscribe(data => {
      this.ai_id = data['ai_id'];
      this.mod_callerid = data['mod_callerid'];
      this.user_role = data['user_role'];
    });
  }

  async ngOnInit() {

    this.buildBlob();
    console.log();
    if (this.items.comments.length > 0) {
      this.comments_array = await this.httpService.getBatchData(this.items.comments, this.items.ai, 0);
      this.comments_array = this.comments_array.Responses.Items;
      this.comments_array = this.comments_array.sort((a, b) => (a.time < b.time ? 1 : -1));

    }
    this.old_obj = {};
    for (let item of this.updatable_field_keys) {
      if ((item === 'tags' || item === 'transcript' || item === 'misc') && !this.items[item])
        this.items[item] = '';
      this.old_obj[item] = this.items[item];
    }

    for (let grievance of this.grievances_data) {
      if (this.items.id === grievance.item_id) {
        this.grievances_id = grievance.id;
        this.reference_id = JSON.parse(this.items.cm_properties).gr_ref_id;
      }
    }
    this.grievanceService.getHandler(this.ai_id).subscribe(value => {
      this.handlers = value.result;
      for (let handler of this.handlers) {
        if (handler.number === '91' + this.mod_callerid) {
          this.handler_id = handler.id;
        }
      }
    });
    this.grievanceService.getQuitReason(this.ai_id).subscribe(value => {
      this.quitreason = value.result;
    });
  }
  
  recordInit() {
    this.audioRecordingService
      .recordingFailed()
      .subscribe(() => (this.isRecording = false));
    this.audioRecordingService
      .getRecordedTime()
      .subscribe(time => (this.recordedTime = time));
    this.audioRecordingService.getRecordedBlob().subscribe(data => {
      this.teste = data;
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
      this.audiofilePath = this.sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
      this.fileName = this.teste.title;
    });
  }

  public enableSave(): void {
    this.isSaveDisabled = true;
  }
 dialogBoxConfirm(message:string, type:string) {
      this.isUpload = false;
      const dialogRef = this.dialog.open(ConfirmBoxComponent, {
              width: '20',
              data: {message: message,
                    ok_text: 'Yes',
                    cancel_text: 'No',
                    ok_color: 'warn',
                    cancel_color: 'primary'}
          }
      );
      dialogRef.afterClosed().subscribe(result => {
        if (result) 
          {
            this.clearRecordedData();
            this.enableSave();
              if (type==='delete') {
              this.isUpload = true;
              }

              else if (type==='record') {
                this.startRecording();
              }
              else if (type==='upload') {
                this.isUpload = true;
                this.waitForDOMElement('.upload-class').then((elm) => { 
                document.getElementById("file-upload").click();
                })
              }
        }
        else {
          this.isSaveDisabled = false;
        }
      });
  }
  micClicked() {
    if (this.audiofilePath) {
      this.dialogBoxConfirm('Do you want to discard this recording?', 'record');
    }
    else {
      this.startRecording();
    }
  }

  clearUpload(){
    let audio = <HTMLInputElement> document.getElementById('audio2');
    if (audio!==null){
      audio.src = null;
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
    this.teste = null;
    this.audiofilePath = null;
    this.fileName='';
  }

  startRecording() {
    this.recordInit();
    this.isUpload = false;
      if (!this.isRecording) {
        this.isRecording = true;
        this.audioRecordingService.startRecording();
      }
    }
  
  stopRecording(): void {
    this.isSaveDisabled = false;
      this.audioRecordingService.stopRecording();
      this.isRecording = false;
    }


uploadButtonClick() {
  console.log(this.audiofilePath);
  if (this.audiofilePath) {
    this.dialogBoxConfirm('Do you want to discard this audio?', 'upload');
  }
  else {
    return;
  }
}
  
  show() {
    this.showOpt = true;
    this.showUpdate = false;
  }
  showUpdates() {
    this.showUpdate = true;
    this.showOpt = false;
  }

  waitForDOMElement(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

fileSelected(fileInput: any) {
    let input = <HTMLInputElement>document.querySelector('input[type=file]');
    this.audiofilePath = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(input.files[0]));
    if (fileInput.target.files && fileInput.target.files[0]) {
      this.audio_file = fileInput.target.files[0];
      this.isSaveDisabled = false;
      this.fileName = this.audio_file.name;
      this.isUpload=false;
    }
  }

  enableFields(option) {
    this.grievances_state = option.value;
    this.enableAudio = true;
  }

  saveGrievance(){
    if (this.audio_file) {
      this.spinner = true;
      this.grievanceService.saveGrievance(this.items, this.old_obj)
          .subscribe((response: any[]) => {
            this.response = response;
            if (this.response.success === 'True') {
              this.toastr.success(this.response.success, 'Updated Successfully');
            } else if (this.response.success === 'False') {
              this.toastr.error(this.response.message, 'Failed');
            }
          });
      // tslint:disable-next-line:max-line-length
      this.httpService.updateOnAssignGrievnace(this.grievances_state, this.grievances_id, this.selectedReason, this.audio_file).subscribe((response: any[]) => {
        this.response = response;
        this.caseManager.ngOnInit();
        this.spinner = false;
      });
    } else {
      this.toastr.info('Select audio file to Save');
    }
  }

  saveRecGrievance(){
    if (this.teste) 
        {
          this.audio_file = new File([this.teste.blob], this.teste.title, {
            type: this.teste.blob.type,
            });
          this.saveGrievance();
        } 
    else 
      {
        this.saveGrievance();
      }
    }

  async assign_grievance() {
    this.spinner = true;
    this.grievanceService.updateGrievance('ASSIGNED', this.handler_id, this.grievances_id, 0).subscribe((response: {result}) => {
      if (response.result === true) {
        this.toastr.success('Grievance Assigned');
        this.caseManager.ngOnInit();
      } else {
        this.toastr.error('Failed to Assign');
      }
    });
  }

  patchCall() {
    let dialogRef = this.confirmDialog(getTranslateText(this.defaultLan, CALL_CONFIRM));
    dialogRef.afterClosed().subscribe(res => {
      if(res) {
        this.mainService.patchCall(this.mod_callerid, this.items.callerid, "3483").subscribe((result: HelplineResult) => {
          if (result.scheduled_call_id) {
            this.openSnackbar(getTranslateText(this.defaultLan, CALL_CONNECTING), 3);
          } else {
            this.openSnackbar(getTranslateText(this.defaultLan, CALL_FAIL), 3);
          }
        });  
      }

    })
  }

  popupImage(index: number) {
  this.dialog.open(ImageViewerComponent, {
    data: {
      currentIndex: index,
      imageList: this.imageList,
    }
  });

  }
  buildBlob() {
    var jsonParser: JsonParsePipe = new JsonParsePipe();
    var miscObj = jsonParser.transform(this.items.misc);
    if (miscObj){
      miscObj.s3_images.forEach((url: string, index: number) => {
        fetch(url)
        .then(response => response.blob())
        .then(blob => {
          var urlObj: BlobFile = {blob: undefined, blobUrl: undefined, fileName: undefined};
          var blobUrl = window.URL.createObjectURL(blob);
          urlObj.fileName = url.split('/').pop();
          urlObj.blobUrl= blobUrl;
          urlObj.blob = blob;
          this.imageList.push(urlObj);
        });
      });
    }
  }

  getSafeUrl(blobUrl: string): SafeUrl {
      return this.sanitizer.bypassSecurityTrustUrl(blobUrl);
  }

  confirmDialog(message: string) {
    return this.dialog.open(ConfirmBoxComponent, {
      data: {message: message,
            ok_text: getTranslateText(this.defaultLan, OK_TXT),
            cancel_text: getTranslateText(this.defaultLan, CANCEL_TXT),
            ok_color: 'primary',
            cancel_color: 'warn'}
      }
    );
  }

  openSnackbar(message: string, duration: number) {
    this.snackbar.open(message, 'Close', {
      duration: duration * 1000
    });
  }
}


